import React, { useState, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';

import { EditOutlined, VisibilityOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { useSelectedLocation } from '../hooks/useSelectedLocation';

const Dashboard = () => {
  const [flyers, setFlyers] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const selectedLocation = useSelectedLocation();

  const navigate = useNavigate();

  const handleEditClick = (flyer) => {
    navigate('/addflyer', { state: { flyer: flyer } });
  };

  useEffect(() => {
    const fetchFlyers = async () => {
      if (!selectedLocation) return;

      try {
        const token = await getAccessTokenSilently();
        const response = await axios.get(`${process.env.REACT_APP_SERVER_DOMAIN}/api/flyers/location/${selectedLocation}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setFlyers(response.data);
      } catch (error) {
        console.error("Error fetching flyers", error);
      }
    };
    fetchFlyers();
  }, [selectedLocation, getAccessTokenSilently]);

  return (
    <div className='dashboard-body-wrapper'>
      <div className='main-column'>
        <div id="page-title-div" className="page-title-div">
          <h3 className="secondary-text">Welcome!</h3>
        </div>
        <div className='div-block'>
          <span className='div-block-title'>Analytics</span>
          <div className='analytics-summary'>
            <div className='analytics-summary-node' key="visits">
              <label className='analytics-summary-node-title'>Visits</label>
              <span className='analytics-summary-node-data'>XXX</span>
            </div>
            <div className='analytics-summary-node' key="opens">
              <label className='analytics-summary-node-title'>Opens</label>
              <span className='analytics-summary-node-data'>XXX</span>
            </div>
            <div className='analytics-summary-node' key="engagement">
              <label className='analytics-summary-node-title'>Engagement</label>
              <span className='analytics-summary-node-data'>XXX</span>
            </div>
            <div className='analytics-summary-node' key="clicks">
              <label className='analytics-summary-node-title'>Clicks</label>
              <span className='analytics-summary-node-data'>XXX</span>
            </div>
          </div>
        </div>
        <div className='div-block'>
          <span className='div-block-title'>Active Flyers</span>
          <div className="flyers-carousel">
            <div className="flyer-thumbnail-new">
              <div className="flyer-thumbnail-wrapper">
                <img className="flyer-thumbnail-img" alt="flyer thumbnail" src='/flyer-preview.png' />
                <Link to="/addflyer" className="flyer-overlay">
                  <span className="overlay-text">+ New Flyer</span>
                </Link>
              </div>
            </div>
            {flyers.map(flyer => (
              <div key={flyer._id} className="flyer-thumbnail" style={{ position: 'relative' }}>
                <img className="flyer-thumbnail-img" alt="flyer thumbnail" src={flyer.preview_image_url || '/flyer-preview.png'} />
                {flyer.pdf_url && (
                  <span style={{
                    position: 'absolute',
                    top: '8px',
                    left: '8px',
                    padding: '2px 8px',
                    fontSize: '11px',
                    fontWeight: 500,
                    color: '#166534',
                    backgroundColor: '#dcfce7',
                    borderRadius: '10px',
                  }}>Published</span>
                )}
                <div className="flyer-buttons">
                  <EditOutlined key="edit" onClick={() => handleEditClick(flyer)} style={{ cursor: 'pointer' }} /><VisibilityOutlined style={{ cursor: 'pointer' }} />
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className='div-block'>
          <span className='div-block-title'>What We're Reading</span>
          <div className='reading-list'>
            <div className='reading-list-node' key="canadian-grocer">
              <a href='https://canadiangrocer.com/products?eiq_7_end=40'><span className='reading-list-node-data'>Canadian Grocer: What's new on shelf</span></a>
            </div>
            <div className='reading-list-node' key="6ps-planning">
              <a href='https://www.smartinplanning.com/blog/2019/2/14/6ps-of-merchandise-planning'><span className='reading-list-node-data'>6 Ps of Merchandise Planning</span></a>
            </div>
            <div className='reading-list-node' key="back-to-school">
              <a href='https://www.grocerydive.com/news/grocers-target-back-to-school-shoppers/692096/'><span className='reading-list-node-data'>How grocers are targeting back to school shoppers</span></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
